export default {
  name: 'RtOriginProgress',
  render(h) {
    return h('el-progress', {
      attrs: this.$attrs,
      props: this.$props,
      class: 'rt-origin-progress'
    });
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/progress/rtOriginProgress.js